import React from 'react'
import PropTypes from 'prop-types'
import { sanitizeProps } from '@fs/zion-frontend-friends'

const BillboardText = ({ primaryColor, secondaryColor, as: TagName = 'span', children, ...props }) => {
  return (
    <TagName
      {...sanitizeProps(props)}
      style={{
        '--special-type-color': primaryColor,
        '--special-type-secondary-color': secondaryColor || primaryColor,
      }}
    >
      {children}
    </TagName>
  )
}
export default BillboardText

BillboardText.propTypes = {
  /** The color that will be used for `--special-type-color` */
  primaryColor: PropTypes.string,

  /** The color that will be used for `--special-type-secondary-color`. Defaults to primaryColor if not set. */
  secondaryColor: PropTypes.string,

  /** HTML element to be rendered (string only). Defaults to 'span'. */
  as: PropTypes.string,

  /** Any typography components within this component's children will have the colors specified by primaryColor and/or secondaryColor */
  children: PropTypes.node.isRequired,
}
